import { LegacyDateRangeFilter } from '@synergy/components';
import { PaloFilterModal } from '@synergy/components-palo';
import { ReactElement } from 'react';
import { UserRole } from '@synergy/models';

import { AccessControl } from '../../../../common/components/access-control/access-control';
import { CustomerContactFilter } from '../../../../common/components/filter/customer-contact-filter';

/**
 * PALO filter for this list: the same dialog filters as the legacy one, without
 * its search field. The list header carries the one search box now, and having
 * both is exactly the duplication the users reported (#2184).
 */
export const PaloDemandsOverviewFilter = (): ReactElement => (
    <PaloFilterModal>
        <LegacyDateRangeFilter />
        <AccessControl allowedRoles={UserRole.ShopAdmin}>
            <CustomerContactFilter />
        </AccessControl>
    </PaloFilterModal>
);
